/**
 * @author Yohann Bianchi<yohann.b@lahautesociete.com>
 * @date 22/08/2018 14:04
 */
import Vue from 'vue';

export const events = {
    MENU_DROPDOWN_OPEN:  'menu-dropdown-open',
    MENU_DROPDOWN_CLOSE: 'menu-dropdown-close',
};

export const EventBus = new Vue();
export default EventBus;
